<template>
  <breadcrumb :links="links"></breadcrumb>

  <div class="container-xl p-0 py-sm-2 px-sm-3">
    <div id="content_container">
      <div id="sidebar" v-if="showSidebar">
        <template v-if="product == 'SRI'">
          <h4 class="text-center mt-4">Precipitazioni</h4>
          <div class="p-2">
            <p>Dall'elaborazione delle grandezze fisiche misurate dal radar è possibile stimare la quantità di pioggia al
              suolo</p>
            <p>In questa mappa vengono mostrate le <strong>piogge instantanee</strong>: la quantità di pioggia stimata da
              una sola acquisizione
              rapportata su un periodo di un'ora.</p>
          </div>
          <div class="d-grid gap-2 p-2">
            <router-link to="/radar_cumulate" class="btn btn-primary">
              Vai alle piogge cumulate
            </router-link>
          </div>
        </template>
        <template v-else>
          <h4 class="text-center mt-4">Riflettività</h4>
          <div class="p-2">
            <p>La riflettività radar rappresenta la misura del segnale elettromagnetico riflesso verso l'antenna,
              viene anche chiamato "eco" e rappresenta la principale grandezza fisica misurata.</p>
            <p>In questa mappa viene mostrata la <strong>riflettività massima</strong> sulla verticale</p>
            <p>Al dato grezzo vengono applicati diverse correzioni software in modo da lasciare solo l'eco dell'acqua
              presente in atmosfera. Occasionali disturbi possono comunque arrivare fino all'immagine finale.</p>
          </div>
        </template>
        <div class="map_legend">
          <Legend :legend="this.legend">
          </Legend>
        </div>
      </div>
      <button class="btn btn-light button" id="close_sidebar" v-on:click="showSidebar = false; showXButton = false"
        v-if="showXButton">
        <i class="bi bi-x-lg p-2"></i>
        <span v-if="product == 'SRI'" class="text-color">Precipitazioni</span>
        <span v-else class="text-color">Riflettività</span>
      </button>
      <div id="map_container">
        <div v-if="!radarAvailable" class="no_radar alert alert-warning alert-dismissible" role="alert">
          <i class="bi bi-exclamation-triangle"></i> {{ radarNotAvailable() }}
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <button v-if="!this.showSidebar" id="show_sidebar" class="btn btn-light button"
          v-on:click="showSidebar = true; showXButton = true">
          <i class="bi bi-list p-2"></i>
          <span class="text-color">Legenda</span>
        </button>
        <button id="toggle_bands" :class="('btn btn-light')"
          :style="showSidebar ? 'left: 260px' : 'left: 60px'" v-on:click="toggleBands()">
          <i :class="'bi bi-arrows-angle-' + (showBands ? 'contract' : 'expand')"></i>
        </button>
        <div class="frame_controls">
          <div class="links" v-if="images && images[current]">
            <a v-for="(image, index) in images" v-bind:key="image.id" :class="index == current ? 'current' : ''"
              v-on:click="current = index"></a>
          </div>
          <div class="info">
            <a :class="'clock' + (radar_time ? ' clock_on' : '')" v-on:click="chooseTime()"></a>
            <a :class="'play_pause' + (animation_id ? ' play_pause_on' : '')" v-on:click="toggleAnimation()"
              v-if="images && images[current]"></a>
            <div class="label" v-if="images && images[current]">
              <span class='time'>{{ convertOnlyTime(images[current].dt).substring(0, 5) }}</span><span class='date'>{{
                convertOnlyDate(images[current].dt) }}</span>
            </div>
          </div>
          <div class="choose_time row justify-content-center" v-if="choose_time_dialog">
            <div class="col-md-2 col-xs-5">
              <input ref="toDateInput" class="form-control" type="date" v-model="inputDate" />
            </div>
            <div class="col-md-2 col-xs-5">
              <input ref="toTimeInput" class="form-control" type="time" v-model="inputTime" />
            </div>
            <div class="col-md-1 col-xs-1 ">
              <a class="btn btn-primary conditional_btn" v-on:click="setRadarTime(true)" v-if="inputDate && inputTime"><i
                  class="bi bi-check-lg"></i></a>
              <a class="btn btn-secondary conditional_btn" v-on:click="setRadarTime(false)"><i class="bi bi-x-lg"></i></a>
            </div>
          </div>
          <div class="fc_bgd"></div>
        </div>
        <div v-if="images && images[current]" ref="oeInput" :class="(showBands ? 'band_oe' : 'd-none')"
          :style="'background-image: url(' + images[current].url_oe + ')'">
          <div v-if="showBands" class="r_height r_height_oe r_height_oe_0"><span>{{ this.heights[0] }}</span></div>
          <div v-if="showBands" class="r_height r_height_oe r_height_oe_1"><span>{{ this.heights[1] }}</span></div>
          <div v-if="showBands" class="r_height r_height_oe r_height_oe_2"><span>{{ this.heights[2] }}</span></div>
          <div v-if="showBands" class="r_height r_height_oe r_height_oe_3"><span>{{ this.heights[3] }}</span></div>
        </div>
        <div v-if="images && images[current]" ref="nsInput" :class="(showBands ? 'band_ns' : 'd-none')"
          :style="'background-image: url(' + images[current].url_ns + ')'">
          <div v-if="showBands" class="r_height r_height_ns r_height_ns_0"><span>{{ this.heights[0] }}</span></div>
          <div v-if="showBands" class="r_height r_height_ns r_height_ns_1"><span>{{ this.heights[1] }}</span></div>
          <div v-if="showBands" class="r_height r_height_ns r_height_ns_2"><span>{{ this.heights[2] }}</span></div>
          <div v-if="showBands" class="r_height r_height_ns r_height_ns_3"><span>{{ this.heights[3] }}</span></div>
        </div>
        <Map class="map" :style="showBands ? 'height: calc(100% - 100px)' : 'top: 0; right: 0;'" :data="imageLayers"
          :current="current" :collapsedLegend="true" @view_changed="adapt2View">
        </Map>
      </div>
    </div>
  </div>

  <app-footer-mini></app-footer-mini>
</template>

<script>
import Map from '@/components/Map/BaseFvgMap'
import Legend from '@/components/Legend'
import MonitorApi from '@/services/MonitorApi';
import Labels from '@/utils/labels';
import Breadcrumb from '@/components/Breadcrumb'
import AppFooterMini from '@/app-footer-mini.vue'
import { imageLayers } from '@/components/Map/MapMarkers';
import { ref } from 'vue';

export default {
  components: { Map, Legend, Breadcrumb, AppFooterMini },
  mixins: [Labels],
  data: function () {
    return {
      product: 'VMI',
      showSidebar: true,
      showBands: false,
      legend: {},
      radarAvailable: true,
      images: [],
      imageLayers: [],
      links: { '/': 'Home', '/radar': 'Radar' },
      heights: ["1 km", "6 km", "12 km", "18 km"],
      current: 0,
      animation_id: undefined,
      choose_time_dialog: false,
      inputDate: undefined,
      inputTime: undefined,
      radar_time: false
    }
  },
  setup() {
    const toDateInput = ref(null);
    const toTimeInput = ref(null);
    const oeInput = ref(null);
    const nsInput = ref(null);

    return {
      toDateInput,
      toTimeInput,
      oeInput,
      nsInput
    };
  },
  methods: {
    toggleSidebar: function () {
      this.showSidebar = !this.showSidebar
    },
    toggleBands: function () {
      this.showBands = !this.showBands
    },
    loadImages: async function () {
      const max_time = 129600000; // 36 h
      let to = new Date;
      if (this.radar_time) {
        to = this.radar_time;
      }
      const from = new Date(to - max_time);
      let products, products_oe, products_ns;
      if (this.product == 'SRI') {
        products = await MonitorApi.getRadarProducts(1, 'SRI', from, to, 10);
        products_oe = await MonitorApi.getRadarProducts(1, 'SRISV_OE', from, to, 10);
        products_ns = await MonitorApi.getRadarProducts(1, 'SRISV_NS', from, to, 10);
      }
      else {
        products = await MonitorApi.getRadarProducts(1, 'VMI', from, to, 10);
        products_oe = await MonitorApi.getRadarProducts(1, 'HVMI_OE', from, to, 10);
        products_ns = await MonitorApi.getRadarProducts(1, 'HVMI_NS', from, to, 10);
      }
      const images = [];
      const extents = [];
      for (let i in products) {
        const p = products[i];
        const pl = p.details.legend;
        const e = p.details.extent
        const p_oe = products_oe[i];
        const p_ns = products_ns[i];
        images.push({
          title: i,
          type: 'image',
          dt: p.dt,
          url: 'https://monitor.protezionecivile.fvg.it/api/products/' + p.id,
          url_oe: 'https://monitor.protezionecivile.fvg.it/api/products/' + p_oe.id,
          url_ns: 'https://monitor.protezionecivile.fvg.it/api/products/' + p_ns.id,
          extent_oe: p_oe.details.extent,
          extent_ns: p_ns.details.extent,
          bounds: [[e[3], e[0]], [e[1], e[2]]]
        });
        extents.push({
          bounds: this.product == 'VMI' ? [[e[0], e[3]], [e[2], e[1]]] : [[e[0], e[1]], [e[2], e[3]]]
        });
        if (i == 0) {
          this.legend = {
            type: 'ramp',
            title: this.product == 'VMI' ? 'Riflettività' : 'Precipitazioni stimate',
            num_colors: 100,
            labels: this.product == 'VMI' ? ['', 'debole', 'moderata', 'forte', 'molto forte'] : ['', 'deboli', 'moderate', 'abbondanti', 'molto abbondanti'],
            stops: []
          };
          const length = pl.colormap.entries.length;
          for (let j = 0; j < length; j++) {
            const e = pl.colormap.entries[j];
            this.legend.stops.push({ color: e.color, value: j / (length - 1) });
          }
        }
      }
      this.images = images;
      this.imageLayers = imageLayers(images, extents);
    },
    chooseTime() {
      if (this.radar_time == undefined) {
        this.choose_time_dialog = true;
      } else {
        this.radar_time = undefined;
        this.loadImages();
      }
    },
    setRadarTime(set_time) {
      if (set_time) {
        const toDate = this.toDateInput.valueAsDate;
        const toTime = this.toTimeInput.valueAsDate;
        toDate.setHours(toTime.getUTCHours());
        toDate.setMinutes(toTime.getMinutes());
        this.radar_time = toDate;
        this.loadImages();
      }
      this.choose_time_dialog = false;
    },
    toggleAnimation() {
      if (this.animation_id == undefined) {
        const me = this;
        this.animation_id = setInterval(function () {
          if (me.current == 0) {
            me.current = me.images.length - 1;
          }
          else {
            me.current--;
          }
        }, 1000);
      }
      else {
        clearInterval(this.animation_id);
        this.animation_id = undefined;
      }
    },

    adapt2View(info) {
      const image = this.images[this.current];
      if (image === undefined) return;

      const scale_x = info.size[0] / (info.bounds[2] - info.bounds[0]);
      const scale_y = info.size[1] / (info.bounds[3] - info.bounds[1]);

      const oe_width = parseInt(scale_x * (image.extent_oe[1] - image.extent_oe[0]));
      const ns_height = parseInt(scale_y * (image.extent_ns[1] - image.extent_ns[0]));

      const pos_x = parseInt(scale_x * (image.extent_oe[0] - info.bounds[0]));
      const pos_y = parseInt(scale_y * (info.bounds[3] - image.extent_ns[1]));

      const e_oe = this.oeInput;
      const e_ns = this.nsInput;


      const maxPos_x = info.size[0] - oe_width;
      const maxPos_y = info.size[1] - ns_height;
      e_oe.style["background-size"] = oe_width + "px 100px";
      e_ns.style["background-size"] = "100px " + ns_height + "px";

      e_oe.style["background-position-x"] = Math.min(maxPos_x, Math.max(0, pos_x)) + "px";
      e_ns.style["background-position-y"] = Math.min(maxPos_y, Math.max(0, pos_y)) + "px";

    }
  },
  mounted: async function () {
    this.showSidebar = false;
    this.product = this.$route.params.product;
    if (this.product == 'SRI') {
      this.links['current'] = "Precipitazioni Radar";
    }
    else {
      this.links['current'] = "Riflettività Radar";
    }
    await this.loadImages();
    this.radarAvailable = (this.images.length > 0);
  }

}
</script>

<style lang="scss" scoped>
.text-color {
  padding: 10px;
  writing-mode: vertical-rl;
  text-orientation: sideways-right;
  transform: rotate(180deg);
  color: #0067b1;
}

.button {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: 50px;
  height: auto;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

#close_sidebar {
  position: absolute;
  left: 200px;
  z-index: 999;
  background-color: #fff;
  opacity: 0.8;
  font-variant: small-caps;
  font-weight: bold;
}

#content_container {
  position: relative;
  width: 100%;
  height: 100%;
}

#map_container {
  height: 100%;
  position: relative;

  .map {
    position: absolute;
    bottom: 0;
    left: 0;
    top: 100px;
    right: 100px;
  }
}

#sidebar {
  z-index: 1010;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 200px;
  background-color: #fff;
  opacity: 0.8;
  overflow: auto;

  h4 {
    text-align: right;
    padding: 5px;
  }

  p {
    font-size: 14px;
    padding: 0 5px;
  }

  #close_sidebar {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    padding: 2px 6px;
    border-radius: 3px;
    border: solid 1px #ccc;
    cursor: pointer;
  }
}

#show_sidebar {
  position: absolute;
  top: 10px;
  left: 0;
  z-index: 2000;
  font-variant: small-caps;
  font-weight: bold;
}

.band_oe {
  position: absolute;
  left: 0;
  top: 0;
  right: 100px;
  height: 100px;
  background-repeat: no-repeat;
}

.band_ns {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100px;
  top: 100px;
  background-repeat: no-repeat;
}

.r_height {
  position: absolute;
  font-size: 10px;
}

.r_height_oe {
  height: 0px;
  width: 100%;
  border-top: dashed 1px #ccc;
  z-index: 1010;

  span {
    display: block;
    float: right;
    margin-top: -8px;
    margin-right: 5px;
  }
}

.r_height_oe_0 {
  bottom: 0;
}

.r_height_oe_1 {
  bottom: 29px;
}

.r_height_oe_2 {
  bottom: 65px;
}

.r_height_oe_3 {
  top: 0;
}

.r_height_ns {
  width: 0px;
  height: 100%;
  border-right: dashed 1px #ccc;
  z-index: 1010;

  span {
    display: block;
    width: 30px;
    transform: rotate(90deg);
    transform-origin: 9px 0;
    margin-top: 15px;
  }
}

.r_height_ns_0 {
  left: 0;
}

.r_height_ns_1 {
  left: 29px;
}

.r_height_ns_2 {
  left: 65px;
}

.r_height_ns_3 {
  right: 0;
}

#toggle_bands {
  position: absolute;
  top: 10px;
  left: 120px;
  z-index: 1015;
}

.map_legend {
  padding-top: 20px;
  height: 350px;
  font-size: 14px;
}

.no_radar {
  position: absolute;
  top: 160px;
  z-index: 2000;
  left: 20px;
  right: 50px;
}

.frame_controls {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;

  .fc_bgd {
    background-color: #fff;
    opacity: 0.5;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .links {
    position: relative;
    z-index: 2010;
    margin: 0 auto;
    width: 300px;
    overflow: auto;

    a {
      display: block;
      float: right;
      width: 30px;
      height: 30px;
      margin: 0 auto;
      background-image: url(../assets/frame.png);
      background-position-x: 30px;
      cursor: pointer;
    }

    a.current {
      background-position-x: 0;
    }
  }

  .info {
    position: relative;
    z-index: 2010;
    margin: 0 auto;
    color: #0067b1;
    font-size: 20px;
    font-weight: bold;

    .play_pause {
      display: block;
      float: right;
      width: 40px;
      height: 40px;
      margin: 0 auto;
      background-image: url(../assets/play_stop.png);
      background-position-x: 0;
      margin-top: 8px;
    }

    .play_pause_on {
      background-position-x: 40px;
    }

    .clock {
      display: block;
      float: left;
      width: 40px;
      height: 40px;
      margin: 0 auto;
      background-image: url(../assets/clock.png);
      background-position-x: 0;
      margin-top: 8px;
    }

    .clock_on {
      background-position-x: 41px;
    }

    .label {
      span.time {
        display: block;
        text-align: center;
      }

      span.date {
        display: block;
        text-align: center;
        font-size: 0.6em;
      }
    }
  }

  .choose_time {
    position: relative;
    z-index: 2010;
    width: 100%;
    padding: 10px;
  }

  @media (max-width: 768px) {
    .conditional_btn {
      display: block;
      margin: 0 auto;
      width: 50%;
      margin-top: 10px;
    }

    .choose_time {
      position: relative;
      z-index: 2010;
      width: 75%;
      padding: 10px;
    }
  }
}
</style>
